
import React, { useState, useEffect } from 'react';
import { Row, Col, Modal } from 'react-bootstrap';
import PhoneInput from 'react-phone-input-2';
import PropTypes from 'prop-types';
import './styles/ContactUsPopUp.scss';

import { loadJS } from 'lib/helpers';
import routes from 'lib/routes';
import useIsMountedRef from 'hooks/useIsMountedRef';
import Blocking from 'components/Blocking';
import EgSpinner from 'components/EgSpinner';
import { api, handleAjaxError, CancelToken } from 'lib/ajax';
import notif from 'lib/notification';

let cancelRequestSource;

export default function ContactUsPopUp({ productDetails, show, onHide }) {

    const isMoutedRef = useIsMountedRef();
    const [block, setBlock] = useState(true);
    const [showContactUs, setShowContactUs] = useState(false);
    const [showSuccessModal, setSuccessModal] = useState(false);
    const [phone, setPhone] = useState("");
    const [submitButton, setSubmitButton] = useState(false);
    const [values, setValues] = useState({
        fullName: "",
        emailAddress: "",
        message: ""
    });

    useEffect(() => {
        if (!showContactUs) { return; }     
        window.onRecaptchaLoadCallback = () => {
            window.grecaptcha.render('eg-recaptcha');
            requestAnimationFrame(() => {
                document.querySelector('#eg-recaptcha > div').style.margin = '0 auto';
            });
        };
        if (!window.grecaptcha) {
            loadJS('https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoadCallback&render=explicit', () => {
                setBlock(false);
            });
        } 
        else {
            window.onRecaptchaLoadCallback();
        }            
    }, [showContactUs]);

    useEffect(() => {
        if (!!show) {
            setShowContactUs(true);
        }
    }, [show]);
    
    //show popup
    const handleShow = (e) => {
        e.preventDefault();
        setShowContactUs(true);
    };

    //hide popup
    const handleClose = () => {
        setShowContactUs(false);
        if (onHide) {
            onHide();
        }
    };

    // const handleSuccessShow = (e) => {
    //     e.preventDefault();
    //     setShowContactUs(true);
    // };

    //hide Success popup
    const handleSuccessClose = () => {
        setSuccessModal(false);
        if (onHide) {
            onHide();
        }
    };

    const handleOnBlur = (event) => {
        if (event.target.value.trim() === "") {
            event.target.closest('div').classList.add("error");
        } else {

            event.target.closest('div').classList.remove("error");

            if (event.target.name === "emailAddress") {
                if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(event.target.value)) {
                    event.target.closest('div').classList.remove("error");
                    event.target.nextSibling.textContent = "This field is required.";
                } else {
                    event.target.closest('div').classList.add("error");
                    event.target.nextSibling.textContent = "Invalid Email.";
                }
            } 
        }
    };

    const handleOnChange = (ev) => {
        setValues({...values, [ev.target.name]: ev.target.value});
    };

    const updatePhone = (phone) => {
        setPhone(phone);
    };

    const handlePhoneBlur = (event) => {
        let p = phone;
        if (event.target.value.trim() !== "") {
            if (!p.match(/^(?!\b(0)\1+\b)(\+?\d{1,3}[. -]?)?\(?\d{3}\)?([. -]?)\d{3}\3\d{4}$/)) {
                event.target.closest('.input-container').classList.add("error");
                event.target.closest('div').parentNode.childNodes[2].textContent = "Invalid phone number.";
            } else {
                event.target.closest('.input-container').classList.remove("error");
            }
        } else {
            event.target.closest('.input-container').classList.remove("error");
        }
    };

    const handleOnSubmit = (e) => {
        e.preventDefault();
        setShowContactUs(false);
        setSuccessModal(true);
    };

    useEffect(() => {
       
        const checkInputs = (values) => {
            let empty = 0;
            let invalid = 0;

            Object.keys(values).forEach(function(key) {
                if (values[key] === "") {
                    empty += 1;
                } else {
                    /* input is not empty */
                    if (key === "emailAddress") {
                        if (!/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(values[key])) {
                            invalid += 1;
                        }
                    } 
                }
                
            });
            return [empty, invalid];
        };
        if (checkInputs(values)[0] === 0) {
            if (checkInputs(values)[1] === 0) {
                setSubmitButton(1);
            } else {
                setSubmitButton(0);
            }
        } else {
            setSubmitButton(0);
        }

    }, [values]);

    async function onSubmit(e) {
        e.preventDefault();
        const $recaptchaElem = document.querySelector('.g-recaptcha-response');
        if (!$recaptchaElem) {
            notif.error('Please verify you are not a robot.');
            return;
        }
        setBlock(true);
        try {
            cancelRequestSource = CancelToken.source();
            const data = new FormData();
            data.append('ebook_iden', productDetails['ebook_iden']);
            data.append('customer_fullname', values.fullName);
            data.append('customer_email', values.emailAddress);
            data.append('customer_phone', phone);
            data.append('customer_msg', values.message);
            data.append('g-recaptcha-response', $recaptchaElem.value);
            await api.httpPost(routes.api.merchantContactUs, data, {
                cancelToken: cancelRequestSource.token
            });
            if (isMoutedRef.current) {
                setBlock(false);
                setShowContactUs(false);
                setSuccessModal(true);
                setValues({
                    fullName: "",
                    emailAddress: "",
                    message: ""
                });
                setPhone("");
            }
        }
        catch (err) {
            handleAjaxError(err);
            isMoutedRef.current && setBlock(false);
        }
    }

    return (
        <>
            <a href="#" className="contact-us-link header-link t-primary" onClick={handleShow}>Contact Us</a>
            <Modal show={showContactUs} onHide={handleClose} className="eg-modal contactUs-modal" centered backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h1>Contact Us</h1>
                        <p className="f17 t-qblue">Have a question about purchasing, downloading or reading this book? Reach out, we&apos;re here to help!</p>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Blocking show={block} message={(<EgSpinner />)} />
                    <form onSubmit={onSubmit}>
                        <Row className="margin-top-50">
                            <Col lg={12} className="input-container margin-bottom-35">
                                <label htmlFor="">Full Name <span className="asterisk">*</span></label>
                                <input type="text" name="fullName" value={values.fullName} onChange={(event) => handleOnChange(event) } onBlur={handleOnBlur} />
                                <span className="error-msg">This field is required.</span>
                            </Col>
                            <Col lg={12} className="input-container margin-bottom-35">
                                <label htmlFor="">Email Address <span className="asterisk">*</span></label>
                                <input type="text" name="emailAddress" value={values.emailAddress} onBlur={handleOnBlur} onChange={(event) => handleOnChange(event) } />
                                <span className="error-msg">This field is required.</span>
                            </Col>
                            <Col lg={12} className="input-container margin-bottom-35">
                                <label htmlFor="">Phone</label>
                                <PhoneInput 
                                    inputProps={{
                                        name: 'phone',
                                        tabIndex: 4,
                                        required: false
                                    }} 
                                    country={'us'}
                                    value={phone} 
                                    onChange={(event)=> updatePhone(event)}
                                    onBlur={(event) => handlePhoneBlur(event)}
                                    placeholder={'XXX-XXX-XXXX'} 
                                />
                                 <span className="error-msg"></span>
                            </Col>
                            <Col lg={12} className="input-container margin-bottom-35">
                                <label htmlFor="">Message <span className="asterisk">*</span></label>
                                <textarea name="message" id="" cols="30" rows="10" value={values.message} onChange={(event) => handleOnChange(event) } onBlur={handleOnBlur}></textarea>
                                <span className="error-msg">This field is required.</span>    
                            </Col>
                            <Col lg={12} className="text-center margin-bottom-35">
                                <div id="eg-recaptcha" className="g-recaptcha" data-sitekey={process.env.REACT_APP_RECAPTCHA_KEY} style={{marginTop:'10px'}}></div>
                            </Col>
                            <Col>
                                <button type="submit" className={"btn btn-md btn-primary w-100 " + (submitButton ? '' : "disabled")}>Submit</button>
                            </Col>
                        </Row>
                    </form>
                </Modal.Body>
            </Modal>
            <Modal show={showSuccessModal} onHide={handleSuccessClose} className="eg-modal contactSuccess-modal" centered backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h1>Message Received</h1>
                        <p className="f17 t-qblue margin-top-20">Your contact request has been sent perfectly. We&apos;ll be in touch soon.</p>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <img src="/images/img-msg-received.jpeg" alt=""/>  
                    <button className="btn btn-lg btn-primary" onClick={handleSuccessClose}>Done</button>          
                </Modal.Body>
            </Modal>
        </>
    );
}
ContactUsPopUp.propTypes = {
    productDetails: PropTypes.object,
    show: PropTypes.bool,
    onHide: PropTypes.func
};
    